<template>
	<div class="allback">
		<div class="zy_content content-nav">
			<img src="@/images/nav_img.png" />
			<span>新闻公告</span><i class="el-icon-arrow-right"></i>&nbsp;<span>公告列表</span>
		</div>
		<el-container class="content">
			<div class=" zy_content clearfix">
				<div class="zy_index_title">
					<img src="@/images/title_back1.png" class="zy_index_titleback" />
					<img src="@/images/zy-title4.png" class="zy_index_titlename" />
					<div class="zy_index_titleright clearfix">
						<div class="zy_index_titlerighttime clearfix">
							<el-date-picker v-model="timeFor" value-format='yyyy-MM-dd' format='yyyy-MM-dd' type="daterange" size='small' range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable></el-date-picker>
						</div>
						<div class="zy_index_titlerightitem active" @click="search">
							<img src="@/images/zy_right1.png" class="zy_index_titlerightback zy_index_titlerightback1" />
							<img src="@/images/zy_right2.png" class="zy_index_titlerightback zy_index_titlerightback2" />
							<div class="zy_index_titlerightinfo text-ellipsis">查询</div>
						</div>
					</div>
				</div>
				<div class="zy_maincont clearfix">
					<div v-if="!noticeList || noticeList.length<=0" class="simulation_empty_msg_content">暂无新闻</div>
					<div class="clearfix" v-if="noticeList && noticeList.length>0">
						<div class="cen_main_2_1_22" :key="item.id" v-for="item in noticeList" @click="toDetails(item)">
							<div class="cen_main_2_1_1">
								<img :src="baseurl + item.cover" v-if="item.cover"/>
								<img src="@/images/new_new.png"  v-else/>
							</div>
							<div class="cen_main_2_1_2">
								<p class="cen_p_1">{{item.releaseTime | spliceForYear}}</p>
								<p class="cen_p_2">{{item.releaseTime | spliceForDay}}</p>
							</div>
							<div class="cen_main_2_1_3">
								<p class="cen_p_3">{{item.title}}</p>
								<p class="cen_p_4" v-html="item.context">
								</p>
							</div>
							<div class="cen_main_2_1_4">
								<img src="@/images/right.png" />
							</div>
						</div>
					</div>
					<div class="all_live_page" v-if="noticeList && noticeList.length>0">
						<el-pagination background @current-change="handleCurrentChange" :current-page="current" :page-size="limit" layout="  prev, pager, next" :total="total">
						</el-pagination>
					</div>
				</div>
			</div>
		</el-container>
	</div>
</template>

<script>
	import { login } from '@/api/user.js'
	import { userNoticeList, userIsRead } from '@/api/notice'
	export default {
		name: 'news',
		data() {
			return {
				limit: 10,
				current: 1,
				total: 0,
				timeFor:[],
				noticeList: []
			}
		},
		created() {
			this.getNotice();
		},
		mounted() {},
		methods: {
			search(){
				this.current = 1;
				this.getNotice()
			},
			toDetails(item) {
				userIsRead({
					notice_id: item.id
				}).then(res => {
					console.log("已读!")
				})
				this.$router.push({
					name: "newsdetail",
					query: {
						id: item.id
					}
				})
			},
			handleCurrentChange: function(page) {
				this.current = page;
				this.getNotice()
			},
			//获取当前用户所能查看公告
			getNotice() {
				userNoticeList({
					current: this.current,
					limit: this.limit,
					startTime: this.timeFor && this.timeFor.length == 2 ? this.timeFor[0] : null,
					endTime: this.timeFor && this.timeFor.length == 2 ? this.timeFor[1] : null,
				}).then(res => {
					this.noticeList = res.data.records
					this.total = res.data.total;
				})
			},
		},
	}
</script>